<template>
  <div style="padding: 30px 0" v-if="company">
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>负责HR</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="12" style="padding-left:20px"
        >姓名：{{ company.hr_contacter_user.hr_name }}</a-col
      >
      <a-col>邮箱：{{ company.hr_contacter_user.hr_email }}</a-col>
      <a-col span="12" style="padding-left:20px"
        >电话：{{ company.hr_contacter_user.hr_mobile }}</a-col
      >
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>公司信息</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px">
        <p>
          <b>公司名称：</b>
          {{ company.name }}
        </p>
      </a-col>
      <a-col span="24" style="padding-left:20px">
        <p>
          <b>公司虚名：</b>
          {{ company.full_name }}
        </p>
      </a-col>
      <a-col span="24" style="padding-left:20px">
        <p>
          <b>公司地址：</b>
          {{ company.address }}
        </p>
      </a-col>
      <a-col span="24" style="padding-left:20px">
        <p>
          <b>融资阶段：</b>
          {{ company.financing_stage_name }}
        </p>
      </a-col>
      <a-col span="24" style="padding-left:20px">
        <p>
          <b>所属行业：</b>
          {{ company.first_category_name }}
          <template v-if="company.second_category_name"
            >-{{ company.second_category_name }}</template
          >
        </p>
      </a-col>
      <a-col span="24" style="padding-left:20px">
        <p>
          <b>公司规模：</b>
          {{ company.scale_name || "暂无介绍" }}
        </p>
      </a-col>
      <a-col span="24" style="padding-left:20px">
        <p>
          <b>公司福利：</b>
          {{ company.tags || "暂无" }}
        </p>
      </a-col>
      <a-col span="24" style="padding-left:20px">
        <p>
          <b>公司介绍：</b>
          {{ company.introduction }}
        </p>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "Company",
  props: ["company"]
};
</script>
